import { render, staticRenderFns } from "./InvoiceTemplatePanel.vue?vue&type=template&id=4b9342a8&"
import script from "./InvoiceTemplatePanel.vue?vue&type=script&lang=js&"
export * from "./InvoiceTemplatePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports